module.exports = __webpack_public_path__ + "static/media/zona_notte.10ada65c.jpg";